import useCurrencyFormatters from "@hooks/useCurrencyFormatters"

import { faIcon } from "@utils/faIcon"

import { Badge } from "@atoms"

import { CreditTotalBadgeProps } from "./CreditTotalBadge.types"

const icon = faIcon({ name: "money-bills", style: "regular" })

export default function CreditTotalBadge(props: CreditTotalBadgeProps) {
    const { total, applied, remaining, size = "md" } = props

    const { formatCurrency } = useCurrencyFormatters()

    const formatted = formatCurrency(total)
    // Before anything is applied the remaining is the total, so the breakdown would only repeat it.
    const tooltip =
        Number(applied) > 0
            ? `Total\n${formatted}\n${formatCurrency(applied)} applied\n${formatCurrency(remaining)} remaining`
            : `Total\n${formatted}`

    return (
        <Badge size={size} variant="icon" icon={icon} tooltip={tooltip}>
            {formatted}
        </Badge>
    )
}
